import { render, staticRenderFns } from "./myWaterUnbound.vue?vue&type=template&id=081c0720&scoped=true"
import script from "./myWaterUnbound.vue?vue&type=script&lang=js"
export * from "./myWaterUnbound.vue?vue&type=script&lang=js"
import style0 from "./myWaterUnbound.vue?vue&type=style&index=0&id=081c0720&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c0720",
  null
  
)

export default component.exports